var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8661 9.16459L30.6406 5.68647H38.3304V2.20834H14.6696V5.68647H25.9085L24.1339 9.16459C16.7281 9.37328 9.9375 10.8573 9.9375 17.2802V36.9896C9.9375 40.4677 12.5638 43.3198 15.971 43.8299L13.1554 46.5892C12.3982 47.3312 12.9188 48.5833 13.9835 48.5833H16.5625C16.8701 48.5833 17.1777 48.4674 17.3906 48.2355L21.7679 43.9458H31.2321L35.6094 48.2355C35.8223 48.4442 36.1299 48.5833 36.4375 48.5833H39.0165C40.0813 48.5833 40.6018 47.3312 39.8446 46.6124L37.029 43.8531C40.4362 43.3198 43.0625 40.4677 43.0625 36.9896V17.2802C43.0625 10.8573 36.2719 9.37328 28.8661 9.16459ZM26.5 40.4677C24.5362 40.4677 22.9509 38.9142 22.9509 36.9896C22.9509 35.065 24.5362 33.5115 26.5 33.5115C28.4638 33.5115 30.0491 35.065 30.0491 36.9896C30.0491 38.9142 28.4638 40.4677 26.5 40.4677ZM38.3304 30.0333H14.6696V18.4396H38.3304V30.0333Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTramIcon);
export default __webpack_public_path__ + "static/media/TramIcon.c932dcb1edbf103e9131e9f4baf03ed0.svg";
export { ForwardRef as ReactComponent };